(function () {
  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function init() {
    var cursor = document.getElementById('cursor');
    if (!cursor) { console.warn('[cursor] missing #cursor'); return; }
    if (typeof TweenMax === 'undefined') { console.warn('[cursor] TweenMax v2 not loaded'); return; }

    document.documentElement.classList.add('custom-cursor');

    var amount = 20;
    var sineDots = Math.floor(amount * 0.3);
    var width = 26;
    var idleTimeout = 150;

    var lastFrame = 0;
    var mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    var dots = [];
    var idle = false;
    var idleTimer;

    function Dot(i) {
      this.index = i;
      this.anglespeed = 0.02;
      this.x = 0; this.y = 0;
      this.scale = 1 - 0.05 * i;
      this.range = width / 2 - (width / 2) * this.scale + 2;
      this.el = document.createElement('span');
      TweenMax.set(this.el, { scale: this.scale });
      cursor.appendChild(this.el);
    }
    Dot.prototype.lock = function () {
      this.lockX = this.x; this.lockY = this.y;
      this.ax = Math.PI * 2 * Math.random();
      this.ay = Math.PI * 2 * Math.random();
    };
    Dot.prototype.draw = function () {
      TweenMax.set(this.el, { x: this.x, y: this.y });
    };

    for (var i = 0; i < amount; i++) dots.push(new Dot(i));

    function startIdle() {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        idle = true;
        dots.forEach(function (d) { d.lock(); });
      }, idleTimeout);
      idle = false;
    }

    function onMouseMove(e) {
      mouse.x = e.clientX - width / 2;
      mouse.y = e.clientY - width / 2;
      startIdle();
    }
    function onTouchMove(e) {
      if (!e.touches || !e.touches[0]) return;
      mouse.x = e.touches[0].clientX - width / 2;
      mouse.y = e.touches[0].clientY - width / 2;
      startIdle();
    }

    window.addEventListener('mousemove', onMouseMove, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: true });

    function render(ts) {
      var x = mouse.x, y = mouse.y;

      dots.forEach(function (dot, i, arr) {
        var next = arr[i + 1] || arr[0];
        dot.x = x; dot.y = y;

        if (!idle || i <= sineDots) {
          var dx = (next.x - dot.x) * 0.3;
          var dy = (next.y - dot.y) * 0.3;
          x += dx; y += dy;
        } else {
          dot.ax += dot.anglespeed;
          dot.ay += dot.anglespeed;
          dot.y = dot.lockY + Math.sin(dot.ay) * dot.range;
          dot.x = dot.lockX + Math.sin(dot.ax) * dot.range;
        }

        dot.draw();
      });

      requestAnimationFrame(render);
    }
    requestAnimationFrame(render);

    // optional boost on magnetic links
    function bindMagneticBoost(root) {
      var scope = root || document;
      var targets = [].slice.call(scope.querySelectorAll(
  'a, button, [role="button"], [onclick], input[type="submit"], input[type="button"], .menu-list__link'
));
      if (!targets.length) return;
      var lead = cursor.firstElementChild;
      targets.forEach(function (el) {
        el.addEventListener('mouseenter', function () {
          TweenMax.to(lead, 0.25, { scale: 2.5, ease: Power2.easeOut });
        });
        el.addEventListener('mouseleave', function () {
          TweenMax.to(lead, 0.25, { scale: 1.0, ease: Power2.easeOut });
        });
      });
    }
    bindMagneticBoost();
    document.addEventListener('shopify:section:load', function (e) { bindMagneticBoost(e.target); });
    document.addEventListener('shopify:section:select', function (e) { bindMagneticBoost(e.target); });
  });
})();
